module.exports = __webpack_public_path__ + "static/media/logo.244d98dd.png";